import {
  BatteryFull,
  Bell,
  ChevronRight,
  FileText,
  Home,
  MapPin,
  Search,
  Send,
  ShoppingCart,
  Signal,
  Star,
  UserRound,
  Wifi,
} from "lucide-react";
import { businessWorkspaces, dealPreview, servicePreview } from "../../data/heroPreview";
import { site } from "../../data/site";
import "../../styles/hero-illustration.css";

const tabs = [
  { Icon: Home, label: "Home" },
  { Icon: Send, label: "Chat" },
  { Icon: Search, label: "Explore" },
  { Icon: FileText, label: "Bookings" },
  { Icon: UserRound, label: "Profile" },
];

export function HeroIllustration() {
  return (
    <div className="hero-illustration" aria-hidden="true">
      <div className="hero-phone product-ui-consumer">
        <div className="phone-screen">
          <div className="phone-top">
            <span>9:41</span>
            <div>
              <Signal size={11} />
              <Wifi size={11} />
              <BatteryFull size={14} />
            </div>
          </div>
          <div className="phone-heading">
            <img src={site.appIcon} alt="" />
            <span>Stratify</span>
            <Bell size={13} />
            <img className="phone-avatar" src={servicePreview.professionals[0].avatar} alt="" />
          </div>
          <p className="phone-greeting">Explore</p>
          <div className="phone-search">
            <Search size={12} />
            <span>What do you need?</span>
          </div>
          <span className="phone-section">Professionals near you</span>
          <div className="phone-people">
            {servicePreview.professionals.map((person) => (
              <span key={person.name}>
                <img src={person.avatar} alt="" />
                <strong>{person.name}</strong>
                <small>{person.role}</small>
              </span>
            ))}
          </div>
          <span className="phone-section">Recent listings</span>
          <div className="phone-feature">
            <img className="phone-feature-photo" src={servicePreview.image} alt="" />
            <div className="preview-listing-identity">
              <img className="studio-avatar studio-logo" src={servicePreview.logo} alt="" />
              <span>
                <strong>{servicePreview.professional}</strong>
                <small>Remote · {servicePreview.location}</small>
              </span>
              <span className="preview-rating">
                <Star size={10} fill="currentColor" />
                {servicePreview.rating}
                <small>({servicePreview.reviews})</small>
              </span>
            </div>
            <span>{servicePreview.title}</span>
            <strong className="phone-listing-price">{servicePreview.price}</strong>
          </div>
          <div className="phone-bottom">
            {tabs.map(({ Icon, label }) => (
              <span className={label === "Explore" ? "selected" : ""} key={label}>
                <Icon size={13} />
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="hero-business product-ui-consumer">
        <strong className="hero-business-title">Business Home</strong>
        <small className="hero-business-subtitle">Your workspaces</small>
        <div className="hero-workspaces">
          {businessWorkspaces.map((workspace) => (
            <div className="hero-workspace" key={workspace.name}>
              <img src={workspace.logo} alt="" />
              <span>
                <strong>{workspace.name}</strong>
                <small>
                  {workspace.area} · {workspace.role}
                </small>
              </span>
              <ChevronRight size={13} />
            </div>
          ))}
        </div>
      </div>
      <div className="hero-deal">
        <div className="hero-deal-media">
          <img src={dealPreview.image} alt="" />
          <span>{dealPreview.savings}</span>
        </div>
        <div className="hero-deal-body">
          <strong>{dealPreview.title}</strong>
          <small>
            {dealPreview.vendor} · {dealPreview.area}
          </small>
          <span className="hero-deal-price">
            {dealPreview.price}
            <s>{dealPreview.referencePrice}</s>
          </span>
          <span className="hero-deal-meta">
            <MapPin size={10} />
            {dealPreview.pickup} · {dealPreview.quantity}
          </span>
          <span className="hero-deal-action">
            Add to cart
            <ShoppingCart size={11} />
          </span>
        </div>
      </div>
    </div>
  );
}
